module.exports = __webpack_public_path__ + "static/media/YF53_1.428ff699.jpg";